import { render } from "./favourite.vue?vue&type=template&id=141bedf5&scoped=true"
import script from "./favourite.vue?vue&type=script&lang=ts"
export * from "./favourite.vue?vue&type=script&lang=ts"

import "./favourite.vue?vue&type=style&index=0&id=141bedf5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-141bedf5"

export default script